import { defineMessages } from 'react-intl';

/** The copy of the step sheet (design rollout-plan c1, c2, c3). */
export const sheetMessages = defineMessages({
  eyebrow: { id: 'app.sml.releases.rollout.sheet.eyebrow', defaultMessage: '{offset} · {day}' },
  sub: {
    id: 'app.sml.releases.rollout.sheet.sub',
    defaultMessage: '{format} on {count, plural, one {# channel} other {# channels}}',
  },
  close: { id: 'app.sml.releases.rollout.sheet.close', defaultMessage: 'Close' },
  goesOut: { id: 'app.sml.releases.rollout.sheet.goesOut', defaultMessage: '{name} goes out' },
  zoneNote: {
    id: 'app.sml.releases.rollout.sheet.zoneNote',
    defaultMessage: 'The time on {name}, in the artist’s time zone ({zone}).',
  },
  state: { id: 'app.sml.releases.rollout.sheet.state', defaultMessage: 'State' },
  caption: { id: 'app.sml.releases.rollout.sheet.caption', defaultMessage: 'Caption' },
  captionNote: {
    id: 'app.sml.releases.rollout.sheet.captionNote',
    defaultMessage: 'The rollout wrote it from the song. Edit it in the Composer.',
  },
  assetTitle: { id: 'app.sml.releases.rollout.sheet.asset', defaultMessage: 'Asset of this step' },
  swapNote: {
    id: 'app.sml.releases.rollout.sheet.swapNote',
    defaultMessage: 'A swap changes the file on every channel of the step. The posts keep their times.',
  },
  channelsTitle: { id: 'app.sml.releases.rollout.sheet.channels', defaultMessage: 'Channels of this step' },
  cannotTake: {
    id: 'app.sml.releases.rollout.sheet.cannotTake',
    defaultMessage: 'takes no {kind, select, image {image post} other {video}}',
  },
  noStory: { id: 'app.sml.releases.rollout.sheet.noStory', defaultMessage: 'takes no story' },
  skip: { id: 'app.sml.releases.rollout.sheet.skip', defaultMessage: 'Skip this step' },
  openComposer: { id: 'app.sml.releases.rollout.sheet.openComposer', defaultMessage: 'Open in Composer' },
  missingTitle: { id: 'app.sml.releases.rollout.sheet.missing.title', defaultMessage: 'This step needs {asset}' },
  missingReel: {
    id: 'app.sml.releases.rollout.sheet.missing.reel',
    defaultMessage:
      'We make a 15 s reel of {title} in its theme, from another part of the song than the teaser, with the default settings. The step fills when it is ready.',
  },
  missingAsset: {
    id: 'app.sml.releases.rollout.sheet.missing.asset',
    defaultMessage: 'We make it in the theme of {title}. The step fills when it is ready.',
  },
  skipTitle: { id: 'app.sml.releases.rollout.skip.title', defaultMessage: 'Skip “{name}”?' },
  skipPostedTitle: {
    id: 'app.sml.releases.rollout.skip.postedTitle',
    defaultMessage: '{names} {count, plural, one {is} other {are}} posted. Skip the other channels?',
  },
  skipCanceled: {
    id: 'app.sml.releases.rollout.skip.canceled',
    defaultMessage:
      '{count, plural, =0 {} one {# scheduled post is canceled. It comes back to your count of this month.} other {# scheduled posts are canceled. They come back to your count of this month.}}',
  },
  skipDeleted: {
    id: 'app.sml.releases.rollout.skip.deleted',
    defaultMessage: '{count, plural, =0 {} one {# draft is deleted.} other {# drafts are deleted.}}',
  },
  skipHidden: {
    id: 'app.sml.releases.rollout.skip.hidden',
    defaultMessage: 'The step is hidden from the plan. It does not count as a gap. “Undo skip” brings it back.',
  },
  skipConfirm: { id: 'app.sml.releases.rollout.skip.confirm', defaultMessage: 'Skip the step' },
  skipKeep: { id: 'app.sml.releases.rollout.skip.keep', defaultMessage: 'Keep it' },
});
